
import { useHistory, useParams } from 'react-router-dom';
import { Button, Card, Form, ListGroup, Modal, Spinner } from 'react-bootstrap';

import { MdSettings } from 'react-icons/md';
import { CardIcon, ContainerMain } from '../Flow/styles';
import { Title, CardHeader } from '../Flow/components/ManageFlow/styles';
import { Box } from '@material-ui/core';
import { RiCloseCircleFill } from 'react-icons/ri';
import { useEffect, useState, useRef } from 'react';
import { deleteField, getFields, postField, updateField, getTiposArquivos } from '../../services/field';
import { useStateValue } from '../../providers/StateProvider';
import { actionTypes } from '../../store/reducer';
import CancelModal from '../../Components/CancelModal';
import { ButtonHeader, FormLabelCustom } from './styles';
import { schema } from './validation';
import { getMaxNumberInData } from '../../utils/getMaxNumberInData';
import Select from 'react-select';


type DataField = {
  id?: number,
  ordem: string,
  titulo: string,
  texto_interno: string,
  formulario: string,
  mascara: number | string,
  validador: string,
  tipo: string,
  texto_ajuda: string,
  obrigatorio: boolean,
  alternativas: any,
  tipo_alternativa?: string,
  limite_replicacoes?: number,
  tipos_arquivos?: string[],
  tamanho_maximo_arquivo?: number,
  tem_dependencia?: boolean,
  campo_dependente?: number | string
}

const Build = () => {
  const history = useHistory();
  const { form_slug, flow_slug } = useParams<{ form_slug: string, flow_slug: string }>();
  const [tipoCampo, setTipoCampo] = useState('Texto');
  const [, setShowOptionsOne] = useState(false);
  const [showOptionsTwo, setShowOptionsTwo] = useState(false);
  const [loading, setLoading] = useState(false);

  const [, dispatch] = useStateValue();

  const [selectedId, setSelectedId] = useState<number | undefined>(undefined);

  const intialState = {
    ordem: '1',
    titulo: '',
    texto_interno: '',
    formulario: form_slug,
    mascara: '',
    validador: '',
    tipo: 'Texto',
    texto_ajuda: '',
    obrigatorio: true,
    alternativas: [],
    limite_replicacoes: 0,
    tipos_arquivos: [],
    tem_dependencia: false,
    campo_dependente: '',
  }
  const [formData, setFormData] = useState<DataField>(intialState);
  const [formsData, setFormsData] = useState<Array<DataField>>([]);
  const [showModalCancel, setShowModalCancel] = useState(false);
  const [errorsFieldRequired, setErrorsFieldRequired] = useState<any | undefined>();
  const [tiposArquivosDisponiveis, setTiposArquivosDisponiveis] = useState<any[]>([]);
  const [tiposArquivosSelecionados, setTiposArquivosSelecionados] = useState<any[]>([]);
  const [loadingTiposArquivos, setLoadingTiposArquivos] = useState<boolean>(false);
  const [tamanhoMaximoArquivo, setTamanhoMaximoArquivo] = useState<number | undefined>(undefined);
  const isMountedRef = useRef(true);

  const handleRemove = async (id: number) => {
    try {
      setLoading(true);
      await deleteField(id, form_slug);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
    await getAllFields();
    setShowModalCancel(false);

  }

  const [showModalNewInput, setShowModalNewInput] = useState(false);

  const handleCloseModalNewInput = () => {
    const getMaxOrder = formsData && getMaxNumberInData<DataField>(formsData, 'ordem');
    intialState.ordem = (getMaxOrder + 1).toString();
    setFormData(intialState);
    setTiposArquivosSelecionados([]);
    setTamanhoMaximoArquivo(undefined);
    setSelectedId(undefined);
    setShowModalNewInput(false);
    setTipoCampo('Texto');
  };

  const handleShowModalNewInput = () => {
    const getMaxOrder = formsData && formsData.length > 0 ? getMaxNumberInData<DataField>(formsData, 'ordem') : 0;
    intialState.ordem = (getMaxOrder + 1).toString();
    setFormData(intialState);
    setTiposArquivosSelecionados([]);
    setTamanhoMaximoArquivo(undefined);
    setSelectedId(undefined);
    setTipoCampo('Texto');
    setShowModalNewInput(true);
  };

  const getAllFields = async () => {
    try {
      setLoading(true);
      const { data } = await getFields(form_slug);
      setFormsData(data || []);
    } catch (error) {
      console.log(error);

    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    isMountedRef.current = true;

    const loadData = async () => {
      await getAllFields();
      if (isMountedRef.current) {
        await loadTiposArquivos();
      }
    };

    loadData();

    return () => {
      isMountedRef.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form_slug]);

  useEffect(() => {
    if (showModalNewInput && (formData.tipo === 'Arquivo' || formData.tipo === 'Multiplos_Arquivos') && tiposArquivosDisponiveis.length === 0 && !loadingTiposArquivos) {
      loadTiposArquivos();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModalNewInput, formData.tipo]);

  const loadTiposArquivos = async () => {
    if (!isMountedRef.current) return;

    try {
      if (!isMountedRef.current) return;
      setLoadingTiposArquivos(true);
      const response = await getTiposArquivos('arquivos');

      if (!isMountedRef.current) return;

      const data = response?.data;

      if (data) {
        let tiposArray = [];

        if (Array.isArray(data)) {
          tiposArray = data;
        } else if (data.results && Array.isArray(data.results)) {
          tiposArray = data.results;
        } else if (data.data && Array.isArray(data.data)) {
          tiposArray = data.data;
        }

        if (!isMountedRef.current) return;

        if (tiposArray.length > 0) {
          const tiposFormatados = tiposArray
            .filter((tipo: any) => tipo.ativo !== false && tipo.extensao)
            .map((tipo: any) => {
              const extensao = tipo.extensao || '';
              const descricao = tipo.descricao || '';
              const label = descricao && descricao.toLowerCase() !== extensao.toLowerCase()
                ? `${extensao.toUpperCase()} - ${descricao}`
                : extensao.toUpperCase();
              return {
                value: extensao,
                label: label,
              };
            });

          if (isMountedRef.current) {
            setTiposArquivosDisponiveis(tiposFormatados);
          }
        } else {
          if (isMountedRef.current) {
            setTiposArquivosDisponiveis([]);
          }
        }
      } else {
        if (isMountedRef.current) {
          setTiposArquivosDisponiveis([]);
        }
      }
    } catch (error) {
      console.error('Erro ao carregar tipos de arquivos:', error);
      if (isMountedRef.current) {
        setTiposArquivosDisponiveis([]);
      }
    } finally {
      if (isMountedRef.current) {
        setLoadingTiposArquivos(false);
      }
    }
  };

  useEffect(() => {
    if (formsData && formsData.length > 0) {
      let getMaxOrder = getMaxNumberInData<DataField>(formsData, 'ordem');
      setFormData({
        ...formData,
        ordem: (getMaxOrder + 1).toString(),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formsData]);


  useEffect(() => {
    const showOptionsOne = tipoCampo === 'Texto' || tipoCampo === 'Numero' || tipoCampo === 'Data' || tipoCampo === 'Area' || tipoCampo === 'Telefone' || tipoCampo === 'Arquivo' || tipoCampo === 'Email';
    const showOptionsTwo = tipoCampo === 'Alternativas' || tipoCampo === 'Alternativas_API' || tipoCampo === 'Matriz' || tipoCampo === 'Multiplos' || tipoCampo === 'Multiplos_API' || tipoCampo === 'Multiplos_Arquivos';

    setShowOptionsOne(showOptionsOne);
    setShowOptionsTwo(showOptionsTwo);

    if (tipoCampo === 'Matriz') {
      setFormData({ ...formData, tipo_alternativa: 'Campo' });
    }

    if (tipoCampo === 'Alternativas' && !formData.tipo_alternativa) {
      setFormData({ ...formData, tipo_alternativa: 'Select' });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tipoCampo]);

  const getAlternativas = () => {
    try {
      return typeof formData.alternativas === 'string'
        ? JSON.parse(formData.alternativas)
        : formData.alternativas;
    } catch (error) {
      console.error('Erro ao parsear alternativas:', error);
      return [];
    }
  }

  const handleErrors = (data: any) => {
    const errors = {};
    schema.validate(data, { abortEarly: false })
      .catch((errorList) => {
        errorList.inner.forEach((error) => {
          const { path, message } = error;
          errors[path] = message;
        });
        setErrorsFieldRequired(errors);
      });

    return errors;
  };

  const handleAddField = async () => {
    const tiposArquivosParaSalvar = (formData.tipo === 'Arquivo' || formData.tipo === 'Multiplos_Arquivos')
      ? tiposArquivosSelecionados.map((item: any) => item.value)
      : formData.tipos_arquivos;

    let tamanhoMaximoFinal: number | undefined = undefined;
    if (tamanhoMaximoArquivo !== undefined && tamanhoMaximoArquivo !== null) {
      const tamanhoEmMB = Math.round(tamanhoMaximoArquivo / 1048576);
      if (tamanhoEmMB > 5) {
        tamanhoMaximoFinal = 5 * 1048576;
      } else if (tamanhoEmMB < 1) {
        tamanhoMaximoFinal = 1 * 1048576;
      } else {
        tamanhoMaximoFinal = tamanhoMaximoArquivo;
      }
    }

    const formDataComTipos = { ...formData, tipos_arquivos: tiposArquivosParaSalvar };

    handleErrors(formDataComTipos);
    if (!formData.ordem ||
      !formData.texto_ajuda ||
      !formData.titulo
    ) {
      dispatch({
        type: actionTypes.SET_FLASH_MESSAGE,
        flashMessage: {
          show: true,
          type: 'error-alt',
          title: 'Error',
          message: 'Campos obrigatórios não foram preenchidos.',
        },
      });
      return;
    }
    try {

      setLoading(true);

      if (selectedId) {
        const { data } = await updateField(
          selectedId,
          form_slug,
          formData.ordem,
          formData.titulo,
          formData.texto_interno,
          formData.texto_ajuda,
          formData.obrigatorio,
          getAlternativas(),
          formData.tipo,
          formData.validador,
          formData.mascara,
          formData.tipo_alternativa,
          formData.limite_replicacoes,
          tiposArquivosParaSalvar,
          formData.tem_dependencia,
          formData.campo_dependente,
          tamanhoMaximoFinal
        );
        if (data) {
          handleCloseModalNewInput();
          getAllFields();
        }
      } else {
        const { data } = await postField(
          formData.ordem,
          formData.titulo,
          formData.texto_interno,
          formData.formulario,
          formData.mascara,
          formData.validador,
          formData.tipo,
          formData.texto_ajuda,
          formData.obrigatorio,
          getAlternativas(),
          formData.tipo_alternativa,
          formData.limite_replicacoes,
          tiposArquivosParaSalvar,
          formData.tem_dependencia,
          formData.campo_dependente,
          tamanhoMaximoFinal
        );
        if (data) {
          handleCloseModalNewInput();
          getAllFields();
        }
      }
      dispatch({
        type: actionTypes.SET_FLASH_MESSAGE,
        flashMessage: {
          show: true,
          type: 'success',
          title: 'Sucesso',
          message: 'Campo salvo com sucesso',
        },
      });

    } catch (error) {
      dispatch({
        type: actionTypes.SET_FLASH_MESSAGE,
        flashMessage: {
          show: true,
          type: 'error-alt',
          title: 'Error',
          message: 'Erro ao salvar campo.',
        },
      });
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddOption = () => {
    const newOption = {
      ordem: '',
      titulo: '',
    };
    setFormData({
      ...formData,
      alternativas: [...formData.alternativas, newOption],
    });

  }

  const handleChange = (event: any) => {
    const { name, value } = event.target;
    if (name === 'tipo') {
      setErrorsFieldRequired(undefined);
    } else {
      errorsFieldRequired?.[name] && delete errorsFieldRequired[name];
    }

    let finalValue = name === 'limite_replicacoes' ? Number(value) : value;

    setFormData({ ...formData, [name]: finalValue });
  }

  return (
    <ContainerMain>
      <Modal show={showModalNewInput} onHide={handleCloseModalNewInput} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Inserir campo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <Form.Group className="mb-3 col-md-6">
              <Form.Label required>Escolha o tipo de Campo</Form.Label>
              <Form.Select placeholder='Selecione' value={tipoCampo} name='tipo' onChange={(e) => { setTipoCampo(e.target.value); handleChange(e) }}>
                <option value="Texto">Texto</option>
                <option value="Numero">Número</option>
                <option value="Data">Data</option>
                <option value="Area">Area</option>
                <option value="Email">Email</option>
                <option value="Telefone">Telefone</option>
                <option value="Arquivo">Arquivo</option>
                <option value="Alternativas">Alternativas</option>
                <option value="Alternativas_API">Alternativas API</option>
                <option value="Multiplos">Multiplos</option>
                <option value="Multiplos_API">Multiplos API</option>
                <option value="Multiplos_Arquivos">Multiplos Arquivos</option>
                <option value="Matriz">Matriz</option>
              </Form.Select >
              <Form.Text className="text-muted">
                Selecione o tipo de campo adequado para a informação a ser inserida pelo usuário
              </Form.Text>
            </Form.Group >

            <Form.Group className="mb-3 col-md-6">
              <FormLabelCustom required>Ordem</FormLabelCustom>
              <Form.Control placeholder="Ordem" name='ordem'
                isInvalid={errorsFieldRequired && errorsFieldRequired?.ordem}
                required value={formData.ordem} onChange={handleChange} />
              {errorsFieldRequired && errorsFieldRequired?.ordem && <Form.Control.Feedback type="invalid">
                Campo obrigatório
              </Form.Control.Feedback>}
              <Form.Text className="text-muted">
                Informe qual a ordem de exibição do campo no formulário
              </Form.Text>
            </Form.Group>

          </div >

          <div className='row'>
            <Form.Group className="mb-3 col-md-8">
              <FormLabelCustom required>Título</FormLabelCustom>
              <Form.Control placeholder="Título"
                isInvalid={errorsFieldRequired && errorsFieldRequired?.titulo}
                required name='titulo' value={formData.titulo} onChange={handleChange} />
              {errorsFieldRequired && errorsFieldRequired?.titulo && <Form.Control.Feedback type="invalid">
                Campo obrigatório
              </Form.Control.Feedback>}
              <Form.Text className="text-muted">
                Informe um título adequado para o campo
              </Form.Text>
            </Form.Group>
            <Form.Group className="mb-3 col-md-4">
              <Form.Label className="d-flex align-items-center">
                <Form.Check
                  type="checkbox"
                  checked={String(formData.obrigatorio) === 'true'}
                  onChange={(e) => setFormData({ ...formData, obrigatorio: e.target.checked })}
                  className="me-2"
                />
                Obrigatório
              </Form.Label>
              <Form.Text className="text-muted">
                Informe se o campo terá preenchimento obrigatório ou não
              </Form.Text>
            </Form.Group>
          </div>

          <div className='row'>
            <Form.Group className="mb-3 col-md-6">
              <FormLabelCustom required>Texto de Ajuda</FormLabelCustom>
              <Form.Control placeholder="Texto de Ajuda" name='texto_ajuda'
                isInvalid={errorsFieldRequired && errorsFieldRequired?.texto_ajuda}
                required value={formData.texto_ajuda} onChange={handleChange} />
              {errorsFieldRequired && errorsFieldRequired?.texto_ajuda && <Form.Control.Feedback type="invalid">
                Campo obrigatório
              </Form.Control.Feedback>}
              <Form.Text className="text-muted">
                Essa informação irá orientar o usuário a preencher corretamente o campo
              </Form.Text>
            </Form.Group>
            <Form.Group className="mb-3 col-md-6">
              <Form.Label>Texto interno</Form.Label>
              <Form.Control placeholder="Texto interno" name='texto_interno' required value={formData.texto_interno} onChange={handleChange} />
              <Form.Text className="text-muted">
                Insira uma orientação de preenchimento do campo
              </Form.Text>
            </Form.Group>

            <Form.Group className="mb-3 col-md-6">
              <Form.Label>Máscara</Form.Label>
              <Form.Control placeholder="Máscara" name='mascara' required value={formData.mascara} onChange={handleChange} />
              <Form.Text className="text-muted">
                A máscara irá definir o formato do conteúdo a ser digitado no campo
              </Form.Text>
            </Form.Group>
            <Form.Group className="mb-3 col-md-6">
              <Form.Label>Validador</Form.Label>
              <Form.Control placeholder="Validador" name='validador' required value={formData.validador} onChange={handleChange} />
              <Form.Text className="text-muted">
                Informe uma expressão regular para validar o preenchimento do campo
              </Form.Text>
            </Form.Group>
            <Form.Group className="mb-3 col-md-6">
              <Form.Check
                type="checkbox"
                id="tem_dependencia"
                label="Adicionar dependência de outros campos"
                name="tem_dependencia"
                checked={formData.tem_dependencia || false}
                onChange={(e) => {
                  setFormData({ ...formData, tem_dependencia: e.target.checked });
                  if (!e.target.checked) {
                    setFormData((prev) => ({ ...prev, campo_dependente: '' }));
                  }
                }}
              />
            </Form.Group>
            {formData.tem_dependencia && (
              <Form.Group className="mb-3 col-md-6">
                <Form.Label>Selecione o campo de dependência</Form.Label>
                <Form.Control
                  as="select"
                  name="campo_dependente"
                  value={formData.campo_dependente || ''}
                  onChange={(e) => {
                    setFormData({ ...formData, campo_dependente: e.target.value });
                  }}
                >
                  <option value="">-- Selecione um campo --</option>
                  {formsData && formsData.length > 0 && formsData.map((campo) => (
                    <option key={campo.id} value={campo.id}>
                      {campo.titulo} (ID: {campo.id})
                    </option>
                  ))}
                </Form.Control>
                <Form.Text className="text-muted">
                  Selecione o campo do qual este campo depende
                </Form.Text>
              </Form.Group>
            )}
          </div>
          {(formData.tipo === 'Multiplos_Arquivos') && (
            <div>
              <Form.Group className="mb-3 col-md-6">
                <Form.Label>Limite de Arquivos</Form.Label>
                <Form.Control
                  type="number"
                  min="1"
                  max="15"
                  step="1"
                  placeholder="Limite de Arquivos"
                  name='limite_replicacoes'
                  required
                  value={formData.limite_replicacoes}
                  onChange={handleChange}
                />
                <Form.Text className="text-muted">
                  Informe o tamanho máximo permitido para upload em MB (mínimo 1, máximo 15). Use as setas para aumentar/diminuir de 1 em 1.
                </Form.Text>
              </Form.Group>
            </div>
          )}
          {(formData.tipo === 'Arquivo' || formData.tipo === 'Multiplos_Arquivos') && (
            <div>
              <Form.Group className="mb-3 col-md-6">
                <Form.Label>Tipos de Arquivos Permitidos</Form.Label>
                <Select
                  key={`select-tipos-${tiposArquivosDisponiveis.length}-${tiposArquivosDisponiveis.map((t: any) => t.value).join('-')}`}
                  isMulti
                  isDisabled={loading || loadingTiposArquivos}
                  isLoading={loadingTiposArquivos}
                  options={tiposArquivosDisponiveis}
                  value={tiposArquivosSelecionados}
                  onChange={(selected: any) => {
                    setTiposArquivosSelecionados(selected || []);
                  }}
                  placeholder={loadingTiposArquivos ? "Carregando tipos de arquivos..." : tiposArquivosDisponiveis.length === 0 ? "Nenhum tipo disponível" : "Selecione os tipos de arquivos permitidos"}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  isSearchable={true}
                  noOptionsMessage={() => 'Nenhum tipo de arquivo disponível.'}
                  loadingMessage={() => 'Carregando tipos de arquivos...'}
                />
                <Form.Text className="text-muted">
                  Selecione os tipos de arquivos permitidos. Deixe vazio para permitir todos os tipos.
                </Form.Text>
              </Form.Group>
              <Form.Group className="mb-3 col-md-6">
                <Form.Label>Tamanho Máximo do Arquivo (MB)</Form.Label>
                <Form.Control
                  type="number"
                  min="1"
                  max="5"
                  step="1"
                  value={tamanhoMaximoArquivo ? Math.round(tamanhoMaximoArquivo / 1048576) : ''}
                  onChange={(e) => {
                    const inputValue = e.target.value.trim();
                    if (!inputValue || inputValue === '') {
                      setTamanhoMaximoArquivo(undefined);
                      return;
                    }
                    let mbValue = parseInt(inputValue);
                    if (isNaN(mbValue)) {
                      setTamanhoMaximoArquivo(undefined);
                      return;
                    }
                    if (mbValue > 5) {
                      mbValue = 5;
                    }
                    if (mbValue < 1) {
                      mbValue = 1;
                    }
                    const value = mbValue * 1048576;
                    setTamanhoMaximoArquivo(value);
                  }}
                  placeholder="Digite o tamanho máximo em MB"
                />
                <Form.Text className="text-muted">
                  Informe o tamanho máximo permitido para upload em MB (mínimo 1 MB, máximo 5 MB). Use as setas para aumentar/diminuir de 1 em 1 MB.
                </Form.Text>
              </Form.Group>
            </div>
          )}
          {formData.tipo === 'Matriz' && <div>
            <Form.Group className="mb-3 col-md-6">
              <Form.Label>Limite de Replicações</Form.Label>
              <Form.Control
                type="number"
                placeholder="Limite de Replicações"
                name='limite_replicacoes'
                required
                value={formData.limite_replicacoes}
                onChange={handleChange}
              />
              <Form.Text className="text-muted">
                Informe o limite de replicações permitido.
              </Form.Text>
            </Form.Group>
          </div>}

          {
            showOptionsTwo && (<>
              {(formData.tipo === 'Alternativas') && (<>
                <Form.Group className="mb-3 col-md-12">
                  <Form.Label>Tipo de Alternativa</Form.Label>
                  <Form.Select placeholder='Selecione' name='tipo_alternativa'
                    onChange={(e) => {
                      setFormData({ ...formData, tipo_alternativa: e.target.value })
                    }}
                    value={formData.tipo_alternativa}
                  >
                    <option value="Select">Select</option>
                    <option value="RadioButton">RadioButton</option>
                  </Form.Select>
                </Form.Group></>)}

              {(formData.tipo === 'Alternativas_API' || formData.tipo === 'Multiplos_API') && (<>
                <div className='row'>
                  <Form.Group className="mb-3 col-md-12">
                    <Form.Label>Adicionar dados (JSON)</Form.Label>
                    <Form.Control as="textarea" placeholder="Adicionar dados como JSON" style={{ height: '300px' }} name='alternativas'
                      defaultValue={JSON.stringify(formData.alternativas)}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </div></>)}

              {(formData.tipo === 'Alternativas' || formData.tipo === 'Multiplos' || formData.tipo === 'Matriz') && (<>
                <div className='row'>
                  <div className="fw-bold">Lista de {formData.tipo === 'Matriz' ? 'Campos' : 'Alternativas'}</div>
                </div>
                {formData.alternativas.map((alternativa, index) => (
                  <div className='row' key={index.toString()}>
                    <Form.Group className="mb-3 col-md-1">
                      <Form.Label>Ordem</Form.Label>
                      <Form.Control placeholder="Ordem" readOnly value={index + 1} onChange={(e) => {
                        formData.alternativas[index].ordem = e.target.value;
                        setFormData({ ...formData });
                      }} />
                    </Form.Group>
                    <Form.Group className="mb-3 col-md-4">
                      <Form.Label>Titulo</Form.Label>
                      <Form.Control placeholder="Titulo" value={alternativa.titulo} onChange={(e) => {
                        formData.alternativas[index].titulo = e.target.value;
                        formData.alternativas[index].ordem = (index + 1).toString();
                        setFormData({ ...formData })
                      }} />
                    </Form.Group>
                    {formData.tipo !== 'Matriz' ?
                      (
                        <Form.Group className="mb-3 col-md-5">
                          <Form.Label>Valor</Form.Label>
                          <Form.Control placeholder="Titulo" value={alternativa.valor} onChange={(e) => {
                            formData.alternativas[index].valor = e.target.value;
                            setFormData({ ...formData })
                          }} />
                        </Form.Group>)
                      : (
                        <Form.Group className="mb-3 col-md-5">
                          <Form.Label required>Escolha o tipo de Campo</Form.Label>
                          <Form.Select placeholder='Selecione' value={alternativa.campo} name='tipo' onChange={(e) => {
                            formData.alternativas[index].campo = e.target.value;
                            setFormData({ ...formData })
                          }}>
                            <option value="Texto">Texto</option>
                            <option value="Numero">Número</option>
                            <option value="Data">Data</option>
                            <option value="Area">Area</option>
                            <option value="Email">Email</option>
                            <option value="Telefone">Telefone</option>
                          </Form.Select>
                          <Form.Text className="text-muted">
                            Selecione o tipo de campo adequado para a informação a ser inserida pelo usuário
                          </Form.Text>
                        </Form.Group>
                      )
                    }
                    <div className='col-md-2 mt-3 pt-2'>
                      <Button variant="danger" onClick={() => {
                        const alternativas = formData.alternativas;
                        alternativas.splice(index, 1);
                        setFormData({ ...formData, alternativas })
                      }}>Remover</Button>
                    </div>
                  </div>
                ))}
                <Button onClick={handleAddOption}>Adicionar</Button>
              </>)}
            </>)
          }
        </Modal.Body >
        <Modal.Footer>
          {loading ? <Spinner animation="border" variant="primary" /> : <>
            <Button variant="danger" onClick={handleCloseModalNewInput}>
              Cancelar
            </Button>
            <Button variant="primary" onClick={handleAddField}>
              Salvar
            </Button></>}
        </Modal.Footer>
      </Modal >
      <Card>
        <CardHeader>
          <Box>
            <CardIcon>
              <MdSettings size={20} />
            </CardIcon>
          </Box>
          <Title>
            Gerenciar Campos
          </Title>
        </CardHeader>
        <Card.Body>
          <ButtonHeader onClick={handleShowModalNewInput}>Incluir Campo</ButtonHeader>
          <ListGroup>
            {formsData.map((form, index) =>
            (
              <ListGroup.Item key={index.toString()}
                className="d-flex justify-content-between align-items-start"> <div className="ms-2 me-auto">
                  <div className="fw-bold">{form.tipo}</div>
                  {form.ordem} - {form.titulo} - {form.obrigatorio ? 'Campo obrigatório' : form.texto_ajuda || 'Campo não obrigatório'}
                </div>
                <div>
                  <Button variant="primary m-2" onClick={async () => {
                    setSelectedId(form.id);
                    setTipoCampo(form.tipo);
                    setFormData(form);
                    let tiposDisponiveis = tiposArquivosDisponiveis;
                    if (tiposDisponiveis.length === 0) {
                      try {
                        setLoadingTiposArquivos(true);
                        const response = await getTiposArquivos('arquivos');
                        const data = response?.data;

                        if (data) {
                          let tiposArray = [];

                          if (Array.isArray(data)) {
                            tiposArray = data;
                          } else if (data.results && Array.isArray(data.results)) {
                            tiposArray = data.results;
                          } else if (data.data && Array.isArray(data.data)) {
                            tiposArray = data.data;
                          }

                          if (tiposArray.length > 0) {
                            tiposDisponiveis = tiposArray
                              .filter((tipo: any) => tipo.ativo !== false && tipo.extensao)
                              .map((tipo: any) => {
                                const extensao = tipo.extensao || '';
                                const descricao = tipo.descricao || '';
                                const label = descricao && descricao.toLowerCase() !== extensao.toLowerCase()
                                  ? `${extensao.toUpperCase()} - ${descricao}`
                                  : extensao.toUpperCase();
                                return {
                                  value: extensao,
                                  label: label,
                                };
                              });
                            setTiposArquivosDisponiveis(tiposDisponiveis);
                          }
                        }
                      } catch (error) {
                        console.error('Erro ao carregar tipos de arquivos:', error);
                      } finally {
                        setLoadingTiposArquivos(false);
                      }
                    }
                    if (form.tipos_arquivos && form.tipos_arquivos.length > 0) {
                      const selecionados = tiposDisponiveis.filter((tipo: any) =>
                        form.tipos_arquivos?.includes(tipo.value)
                      );
                      setTiposArquivosSelecionados(selecionados);
                    } else {
                      setTiposArquivosSelecionados([]);
                    }
                    setTamanhoMaximoArquivo(form.tamanho_maximo_arquivo || undefined);
                    setShowModalNewInput(true);
                  }}>Detalhes</Button>
                  <Button variant="danger" onClick={() => {
                    setSelectedId(form.id);
                    setShowModalCancel(true);
                  }}>Remover</Button>
                </div>
              </ListGroup.Item>
            ))}
          </ListGroup>
          {loading && <Spinner animation="border" variant="primary" />}

        </Card.Body>
        <Box style={{ display: 'flex', marginLeft: 22, marginBottom: 46 }}>

          <Button
            className="button"
            style={{ backgroundColor: '#EC4C47', border: 0, display: 'flex', alignItems: 'center' }}
            onClick={() => history.push(`/informacoes/${flow_slug}`)}>
            <RiCloseCircleFill size={20} />
            <span style={{ marginLeft: 8 }}>
              Fechar
            </span>
          </Button>
        </Box>
      </Card>
      <CancelModal
        show={showModalCancel}
        handleShow={setShowModalCancel}
        title="Remover Campo"
        description='Tem certeza que deseja remover o campo?'
        handleActionOk={() => handleRemove(selectedId)}
        loading={loading}
      />
    </ContainerMain >
  );
}
export default Build;